module.exports = __webpack_public_path__ + "img/7.5b9da4fd.jpg";